import React from 'react';
import { Drawer } from 'antd';
import MyScenes from '@src/components/my-scenes';

export default function MyScenesDrawer({ isOpen, setIsOpen }) {
  return (
    <Drawer
      open={isOpen}
      onClose={() => setIsOpen(false)}
      closeIcon={false}
      footer={false}
      width={'90%'}
      zIndex={1001}
    >
      <MyScenes isFromDrawer={true} />
    </Drawer>
  );
}
